import React, { useEffect, useState } from "react";
import { getCrm, deleteCrm } from "../services/firestoreService"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import PageHead from "../components/common/PageHead";

const CRM = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCRM = async () => {
      try {
        const data = await getCrm(); 
        setRequests(data || []);
      } catch (err) {
        setError("Failed to load CRM submissions.");
      } finally {
        setLoading(false);
      }
    };
    fetchCRM();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this CRM request?")) return;
    try {
      await deleteCrm(id);
      setRequests((prev) => prev.filter((a) => a.id !== id));
    } catch (err) {
      setError("Failed to delete.");
    }
  };

  if (loading) return <p className="text-center mt-4">Loading CRM submissions...</p>;
  if (error) return <p className="text-center mt-4 text-red-500">{error}</p>;

  return (
    <>
      <PageHead name="CRM Consultation Requests" />
      <div className="container mx-auto p-6 max-w-screen-lg">
        <div className="overflow-x-auto">
          <table className="min-w-full bg-gray-100 table-auto text-left my-6 border border-gray-600">
            <thead className="bg-gray-200 text-gray-700 text-lg">
              <tr>
                <th className="border border-gray-600 px-4 py-2 w-1/12">#</th>
                <th className="border border-gray-600 px-4 py-2">Name</th>
                <th className="border border-gray-600 px-4 py-2">Email</th>
                <th className="border border-gray-600 px-4 py-2">Agency</th>
                <th className="border border-gray-600 px-4 py-2">Website</th>
                <th className="border border-gray-600 px-4 py-2">Plan</th>
                <th className="border border-gray-600 px-4 py-2">Topic</th>
                <th className="border border-gray-600 px-4 py-2 max-w-xs">Message</th>
                <th className="border border-gray-600 px-4 py-2 w-1/12">Action</th>
              </tr>
            </thead>
            <tbody>
              {requests.length > 0 ? (
                requests.map((r, index) => (
                  <tr key={r.id} className="border-b border-gray-600 hover:bg-gray-100 transition">
                    <td className="px-4 py-3 border border-gray-600 text-center">{index + 1}</td>
                    <td className="px-4 py-3 border border-gray-600">{r.name}</td>
                    <td className="px-4 py-3 border border-gray-600 break-words">{r.email}</td>
                    <td className="px-4 py-3 border border-gray-600">{r.agencyName}</td>
                    <td className="px-4 py-3 border border-gray-600 break-words">
                      {r.website || "—"}
                    </td>
                    <td className="px-4 py-3 border border-gray-600">{r.plan}</td>
                    <td className="px-4 py-3 border border-gray-600">{r.topic}</td>
                    <td className="px-4 py-3 border border-gray-600 break-words max-w-xs">
                      {r.message}
                    </td>
                    <td className="px-4 py-3 border border-gray-600 text-center">
                      <button
                        onClick={() => handleDelete(r.id)}
                        className="p-2 rounded text-red-500 hover:bg-red-500 hover:text-white"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center py-4">
                    No CRM consultation requests found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CRM;
